// src/telemetry/constants/modules.ts

export const MODULES = {
  AUTHENTICATION: 'Authentication',

  DASHBOARD: 'Dashboard',

  SEO_MANAGER: 'SEO Manager',

  UTILITY_MANAGER: 'Utility Manager',

  CONTENT_MANAGER: 'Social Media Manager',

  WEBSITE_BUILDER: 'Website Builder',

  GMB_MANAGER: 'GMB Manager',

  REPORTING: 'Reporting',

  PROFILE: 'Profile',

  // BILLING: 'Billing',

  SUPPORT: 'Support',

  // NOTIFICATIONS: 'Notifications',

  AI_ASSISTANT: 'AI Assistant',

  // SETTINGS: 'Settings',
} as const;

export type ModuleName =
  typeof MODULES[keyof typeof MODULES];